const InputDate = ({ label, value, setValue, createdAt, setCreatedAt }) => {
	// Use the new props if provided, otherwise fall back to the old ones for backward compatibility
	const dateValue = value !== undefined ? value : createdAt;
	const setDateValue = setValue !== undefined ? setValue : setCreatedAt;
	const labelText = label || "Creado En";

	return (
		<div className="mb-3">
			<label className="form-label">
				{labelText} <span className="text-danger">*</span>
			</label>
			<input
				type="date"
				className="form-control form-control-lg bg-white bg-opacity-5"
				value={dateValue ? new Date(dateValue).toISOString().slice(0, 10) : ""}
				onChange={(e) => setDateValue(e.target.value)}
			/>
		</div>
	);
};

export default InputDate;
